import StartSoon from './StartSoon';

export default StartSoon;
